// Anime Devta serves its approved static storefront from public/.
// This bundle intentionally renders nothing on those pages; React mounts
// only if a #root container is ever added back.
const container = document.getElementById('root');
if (container) {
  import('./App');
}
